import * as React from "react";
import {useRouteMatch} from "react-router-dom";

import {ConversionContextProvider, enums} from "@khan/analytics-learning-time";
import {useLocation} from "@khan/urls";

import {ContentCache} from "#content-library/data-access/content-cache/content-cache.tsx";

export default function TopLevelContentRouteInternal({
    component: Component,
}: {
    component: React.ComponentType<any>;
}) {
    const match = useRouteMatch();
    const {search} = useLocation();

    return (
        <ConversionContextProvider
            learningTimeInfo={{
                product: enums.Product.OTHER_PRODUCT,
            }}
        >
            <ContentCache>
                <Component
                    // NOTE(john): We need to be able to get rid of these props if we
                    // want to upgrade to React Router v6. Finding where this is being
                    // used is going to be challenging, though!
                    {...match.params}
                    search={search}
                    // NOTE(john): When we switch to React Router v6, we should adopt
                    // something like this, instead:
                    // https://estevanmaito.me/blog/accessible-navigation-using-react-router
                    // https://www.gatsbyjs.com/blog/2020-02-10-accessible-client-side-routing-improvements/
                    // Let screen reader knows that the component has loaded.
                    // TODO(jeff, WEB-677): This should change. This is going
                    // to make the entire content a "live" region that will announce
                    // all its content changes. It also won't announce anything when
                    // first rendered, most likely. Getting aria-live usage right
                    // is hard but we likely want to have a separate unchanging
                    // div that announces this content changing on navigation
                    // instead of this.
                    aria-live="polite"
                />
            </ContentCache>
        </ConversionContextProvider>
    );
}
